import { render, staticRenderFns } from "./Dashboard_arin.vue?vue&type=template&id=2ba30728&scoped=true&"
import script from "./Dashboard_arin.vue?vue&type=script&lang=js&"
export * from "./Dashboard_arin.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_arin.vue?vue&type=style&index=0&id=2ba30728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba30728",
  null
  
)

export default component.exports